export default __webpack_public_path__ + "static/media/download.f08840f3.svg";